import Bugsnag from '@bugsnag/js';

export const reportError = (e: Error) => window.env.ALERTS_BUGSNAG_API_KEY && Bugsnag.notify(e);
